var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-alert"},[_vm._t("icon",function(){return [_c(_setup.SvgAttention,{staticClass:"base-alert__icon"})]}),_vm._t("default",function(){return [_c('span',{staticClass:"base-alert__text"},[_vm._v(" "+_vm._s(_setup.props.text)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }